export function CheckDoubleIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M8.943 17.471L7.5 18.914l-5.207-5.207a1 1 0 111.414-1.414L7.5 16.086l.025-.025c.424.424.895.892 1.418 1.41zM10.207 13.379l7.086-7.086a1 1 0 011.689.897L11.5 14.672l-1.293-1.293z"
      ></path>
      <path
        fill="currentColor"
        d="M11.5 18.914L22.707 7.707a1 1 0 00-1.414-1.414L11.5 16.086l-3.793-3.793a1 1 0 00-1.414 1.414l5.207 5.207z"
      ></path>
    </svg>
  );
}
